import React from 'react';
import Input from './Generic/Input';
import { components } from 'react-select';
import { addClassNames } from '../Functions/Helper/Component';
import { PlusCircle as AddIcon } from './Generic/Icons';
import useRole from '../Provider/TableContext/RoleContext';
import RoleStatus from '../Constants/RoleStatus.json';
import useActionDialog from '../Provider/ActionDialogContext';

export default function RoleSelectionCreateIfEmpty({className, setFirstValue, value, onChange, CreateIfEmpty, ...props}) {
    const { roles: _roles, deleteRole, loading } = useRole();
    const roles = React.useMemo(() => _roles.filter(role => [RoleStatus.Previous, RoleStatus.Current].includes(role.mcb_rolestatus))
        .sort((a, b) =>  Date.parse(b.mcb_starteddate) - Date.parse(a.mcb_starteddate))
    , [_roles]);

    React.useEffect(() => {
        if (
            setFirstValue
            && !value
            && roles[0]?.mcb_roleid 
            && typeof onChange === 'function'
        ) {
            onChange(roles[0]?.mcb_roleid);
        }
    }, [setFirstValue, value, roles, onChange]);

    if (props.onCreateOption) {
        const onCreateOption = props.onCreateOption;
        props.components = Object.assign(props.components || {}, {
            MenuList: ({children, ...props}) => (
                <components.MenuList {...props}>
                    <button
                        type="button"
                        onClick={() => onCreateOption("")}
                        className="btn btn-light w-100 "
                    ><AddIcon className="icon"/> Add new Role</button>
                    {children}
                </components.MenuList>
            )
        
        });
        if (onCreateOption && CreateIfEmpty && !roles.length) {
            onCreateOption("");
        }
    }
    const { confirm } = useActionDialog();
    
    return (
        <div>
            <Input
                {...props}
                type='select'
                isLoading={loading}
                className={addClassNames('primary-select', className)}
                options={roles.map(role => ({
                    label: (<>
                        <span>{role.mcb_roletitle}</span><br/>
                        <i><small>at {role.mcb_rolecompanyname}</small></i>
                    </>),
                    value: role.mcb_roleid
                }))}

                value={value || ""} onChange={onChange}
                onDeleteOption={async (roleId)=> {
                    if(await confirm("This action cannot be undone, are you sure?")) {
                        deleteRole(roleId);
                    }
                }}
            />
        </div>
    );
}